export function attendanceBadgeCount(counts) {
  const raw = counts?.unattended ?? counts?.unread ?? 0;
  return Math.max(0, Number(raw) || 0);
}
